import Table from "../components/confirmPermits/Table";
import Card from "../components/confirmPermits/Card";
import Translate from "../utils/Translate";
import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useSnackbar } from "notistack";
import YesOrNoDialog from "../components/YesOrNoDialog";
import { useNavigate, useParams } from "react-router-dom";
import {
  getPermitGroup,
  getPermit,
  doDeletePermit,
  getPermitPdfBlob,
  getLogoDataUrl,
  getDataIdDetails,
  logout,
  getBackendBaseUrl,
  getHolderActor,
  updateHolderActorElectronicContacts,
} from "../components/confirmPermits/permitApi";
import BankIdAuthentication from "../components/bankId/BankIdAuthentication";
import download from "downloadjs";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BankIdIcon from "../components/bankId/BankIdIconWhite";
import LogoutIcon from "@mui/icons-material/Logout";
import Preloader from "../components/Preloader";
import { Typography, Button } from "@mui/material";
import PersonElectronicContactsCrud from "../components/actors/crud/PersonElectronicContactsCrud";
import PermitDetailsDialog from "../components/actor-permits/responsible-view/PermitDetailsDialog";
import ConfirmDeleteUnsignedPermitDialog from "../components/permits/ConfirmDeleteUnsignedPermitDialog";

const ConfirmPermits = () => {
  console.log("re-render");
  const params = useParams();
  const navigate = useNavigate();
  const actorPermitGroupId = Number(params.actorPermitGroupId);
  const actorPermitId = Number(params.actorPermitId);
  const [data, setData] = useState(false);
  const [isSubmitLoading] = useState(false);
  const [editPermitContacts, setEditPermitContacts] = useState(null);
  //const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showSignatureDialog, setShowSignatureDialog] = useState(false);
  const [isAlreadySigned, setIsAlreadySigned] = useState(false);
  const [showDownloadPdfReminder, setShowDownloadPdfReminder] = useState(false);
  const smallScreen = useMediaQuery("(max-width:800px)");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [companyInfo, setCompanyInfo] = useState(false);
  const [permitToView, setPermitToView] = useState(null);

  useEffect(() => {
    /* sessionStorage.setItem("bidURL",window.location.href); */
    const load = async () => {
      Translate.loadPreLogin();
      await apiLoadPermits();
    };
    load();
  }, []);

  const loginCheck = (responseData) => {
    if (responseData.errorMessageTranslationKey === "logInAgain") {
      // login cookie timeout
      const encryptedData = sessionStorage.getItem("permitSignEncryptedData");
      if (encryptedData) {
        if (actorPermitId) {
          navigate(`/login/permit-sign/${encryptedData}`);
        }
        if (actorPermitGroupId) {
          navigate(`login/permit-sign/group/${encryptedData}`);
        }
      }
      navigate("/"); // vi hittar ingen krypterad nyckel - gå till vanliga eport.se inloggningssida
    }
  };

  const displayApiError = (responseData) => {
    const translationKey = responseData?.errorMessageTranslationKey ?? "SomethingFailed";
    const successMessage = enqueueSnackbar(Translate.get(translationKey), {
      variant: "error",
      autoHideDuration: 6000,
      onClick: () => closeSnackbar(successMessage),
    });
  };

  const apiLoadPermits = async () => {
    let ret = [];
    if (actorPermitGroupId) {
      ret = await getPermitGroup(actorPermitGroupId);
    } else if (actorPermitId) {
      ret = await getPermit(actorPermitId);
    } else {
      return; // vare sig permitgroup eller permitid - inget att göra
    }

    if (ret.isSuccessful === false) {
      loginCheck(ret);
      displayApiError(ret);
    }

    const permits =
      ret.actorPermitGroup?.actorPermits ?? // antingen en körtillståndsgrupp
      (ret.actorPermit ? [ret.actorPermit] : []); // eller ett ensamt körtillstånd
    setData(permits);
    const alreadySigned = ret.actorPermitGroup
      ? ret.actorPermitGroup?.responsibleSignatureDate
        ? true
        : false
      : ret.actorPermit?.signatureDate
        ? true
        : false;

    setIsAlreadySigned(alreadySigned);
    getCompanyInfo();

    return permits;
  };

  const apiDeletePermit = async (id, message) => {
    setShowDeleteDialog(false);
    setDeleteLoading(true);
    const ret = await doDeletePermit(id, message);
    //const ret = await performDelete(`${permitsUrl}${id}/for-responsible`);
    console.log("apiDeletePermit", ret, id);
    if (ret.isSuccessful === false) {
      loginCheck(ret);
      displayApiError(ret);
    } else {
      const successMessage = enqueueSnackbar(Translate.get("PermitDeleted"), {
        variant: "success",
        autoHideDuration: 6000,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        onClick: () => closeSnackbar(successMessage),
      });
    }
    apiLoadPermits();
    setDeleteLoading(false);
  };
  if (!data) {
    apiLoadPermits();
  }

  const getSignatureUrl = () =>
    actorPermitGroupId
      ? `${getBackendBaseUrl()}permits/v2/groups/sign`
      : actorPermitId
        ? `${getBackendBaseUrl()}permits/v2/sign`
        : null;

  const getSignaturePostData = () =>
    actorPermitGroupId
      ? { actorPermitGroupId: actorPermitGroupId }
      : actorPermitId
        ? { actorPermitId: actorPermitId }
        : null;

  async function onBankIdSignatureSuccess() {
    let permits = await apiLoadPermits();
    setShowSignatureDialog(false);

    if (permits != null && permits[0]?.signatureDate) {
      setShowDownloadPdfReminder(true);
    }
  }

  async function onBankIdSignatureFailure(_, response) {
    displayApiError(response?.data);
    setShowSignatureDialog(false);
  }

  const validatePermits = () => {
    console.log("Validate permits");
    setShowSignatureDialog(true);
  };

  const permitPdfClick = async (permit) => {
    console.log("permitPdfClick", permit);
    //setPdfLoading(true);
    setPdfLoading((prevState) => [...prevState, permit.actorPermitId]);

    const blob = await getPermitPdfBlob(permit.actorPermitId);
    if (blob.isSuccessful === false) {
      loginCheck(blob);
      displayApiError(blob);
      //setPdfLoading(false);
      setPdfLoading((prevState) => prevState.filter((item) => item !== permit.actorPermitId));
      return;
    }
    const pPrefix = Translate.get("ActorPermit");
    const filename = `${pPrefix}_${permit.skillGroupDescription}_${permit.actorName}.pdf`;
    download(blob, filename, blob.type);
    //setPdfLoading(false);
    setPdfLoading((prevState) => prevState.filter((item) => item !== permit.actorPermitId));
  };
  const deletePermit = (permit) => {
    console.log("deletePermit", permit);
    setShowDeleteDialog(permit);
  };

  const editPermitContactsClick = (permit) => setEditPermitContacts(permit);

  const getCompanyInfo = async () => {
    const cData = await getDataIdDetails();
    const cLogo = await getLogoDataUrl();

    const cInfo = {
      logo: cLogo || "data:,",
      companyName: cData.companyName || "", //Ska nog vara addressStreet1, kan vara null
      webPage: cData.webPage || "", //Är alltid en tom stäng om saknas behöver ingen OR
    };
    console.log(cInfo);
    console.log(cData);
    console.log(cLogo);
    setCompanyInfo(cInfo);
  };
  const [showLogOut, setShowLogOut] = useState(false);
  const logOut = async () => {
    await logout();
    setShowLogOut(true);
  };

  const getLoginUrl = () => {
    const baseGuiUrl = window.global?.isKs ? "https://app.kortillstand.se/" : "https://eport.se/";

    if (actorPermitGroupId) {
      return `${baseGuiUrl}login/permit-sign/group/${sessionStorage.permitSignEncryptedData}`;
    }
    return `${baseGuiUrl}login/permit-sign/${sessionStorage.permitSignEncryptedData}`;
  };

  if (showLogOut) {
    return (
      <div className={(smallScreen ? "loginPagePermitsMobile" : "loginPagePermits") + " stdFlexCenter"}>
        <div className="loginBox">
          <div className="loginLogo">
            <img width={"300px"} src="/static/Kortillstand-se_Logo_svart.svg" />
          </div>
          <div className="stdFlexCenterCol" style={{ marginTop: "16px", gap: "16px" }}>
            <div> {Translate.get("YouAreNowLoggedOut")}</div>
            <Button
              className="regularButtonWithIcon stdLightLoader"
              loading={isSubmitLoading}
              variant="contained"
              fullWidth={true}
              //disabled={submitDisabled}
              //component={Link}
              href={getLoginUrl()}
              //startIcon={<BankIdIcon width={'30px'}/>}
            >
              {Translate.get("LogIn")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
  if (!data) {
    return <Preloader />;
  }
  return (
    <>
      {!!permitToView && (
        <Dialog open onClose={() => setPermitToView(null)} className="bigCourseDialog" maxWidth={false} scroll="paper">
          <PermitDetailsDialog permit={permitToView} onClose={() => setPermitToView(null)} />
        </Dialog>
      )}
      {/* {!data && <Preloader />} */}
      <Box className="pageWithFooter">
        {/*  <div className="simpleLogoTop">
         <img
           className="simpleLogoTopImg"
           src="/static/Instructor-Portal_App-logo_DESKTOP.png"
         />
       </div> */}
        <div className="headerSpaceBetween">
          <div>Signering av körtillstånd</div>
          <div></div>
          <div>
            <Button
              className="regularButtonWithIcon stdLightLoader"
              loading={false}
              variant="text"
              fullWidth={false}
              startIcon={<LogoutIcon width={"30px"} />}
              onClick={() => logOut()}
              //component={Link}
              //to="/about"
            >
              {Translate.get("LogOut")}
            </Button>
          </div>
        </div>

        {smallScreen && (
          <Card
            data={data}
            permitPdfClick={permitPdfClick}
            permitViewClick={(permit) => setPermitToView(permit)}
            pdfLoading={pdfLoading}
            editPermitContacts={editPermitContactsClick}
            deletePermit={deletePermit}
            deleteLoading={deleteLoading}
            signed={isAlreadySigned}
            issuer={actorPermitGroupId}
          />
        )}
        {!smallScreen && (
          <Table
            data={data}
            permitPdfClick={permitPdfClick}
            permitViewClick={(permit) => setPermitToView(permit)}
            pdfLoading={pdfLoading}
            editPermitContacts={editPermitContactsClick}
            deletePermit={deletePermit}
            deleteLoading={deleteLoading}
            signed={isAlreadySigned}
            issuer={actorPermitGroupId}
          />
        )}
        {/* <Button
        className="regularButtonWithIcon stdLightLoader"
        loading={isSubmitLoading}
        disabled={isAlreadySigned}
        variant="outlined"
        //disabled={submitDisabled}
        onClick={() => validatePermits(actorData)}
      >
        {Translate.get("SignBankID")}
      </Button> */}
        <div className="stdFlexCenter" style={{ display: !isAlreadySigned && "none" }}>
          <CheckCircleOutlineIcon color="primary" sx={{ fontSize: "50px" }} />
          <div>{Translate.get("KsSignDone")}</div>
        </div>
        <div className="stdFlexCenter">
          <Button
            className="regularButtonWithIcon stdLightLoader"
            loading={isSubmitLoading}
            variant="contained"
            fullWidth={false}
            sx={{ display: isAlreadySigned && data?.length > 0 && "none" }}
            startIcon={<BankIdIcon width={"30px"} />}
            //disabled={isAlreadySigned}
            onClick={() => validatePermits()}
          >
            {Translate.get("SignBankID")}
          </Button>
        </div>
        <div></div>
        <hr />
        <div className="footerSpaceBetween">
          <div className="fsbLeft">
            <img style={{ maxWidth: "178px", maxHeight: "70px" }} src={companyInfo.logo} />
            <div>
              <b>{companyInfo.companyName}</b>
              <br />
              {companyInfo.webPage}
            </div>
          </div>
          <hr />
          <div className="fsbRight">
            <div>{Translate.get("KsCreatedBy")}</div>
            <img style={{ width: "178px" }} src="/static/Kortillstand-se_Logo_svart.svg" />
          </div>
        </div>
      </Box>
      <ConfirmDeleteUnsignedPermitDialog
        open={showDeleteDialog !== false}
        operatorName={showDeleteDialog.actorName}
        onYes={(message) => apiDeletePermit(showDeleteDialog.actorPermitId, message)}
        onNo={() => setShowDeleteDialog(false)}
      />
      <Dialog open={showSignatureDialog} onClose={() => setShowSignatureDialog(false)}>
        <DialogTitle textAlign="center">{Translate.get("SignBankID")}</DialogTitle>
        <DialogContent>
          {/* Det ska vara en egen komponent för signatur */}
          <BankIdAuthentication
            fetchStatusIncludeCredentials={true}
            startAuthenticationUrl={getSignatureUrl()}
            postData={getSignaturePostData()}
            onAuthenticationSuccess={onBankIdSignatureSuccess}
            onAuthenticationFailure={onBankIdSignatureFailure}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={showDownloadPdfReminder} onClose={() => setShowDownloadPdfReminder(false)}>
        <DialogTitle textAlign="center"></DialogTitle>
        <DialogContent>
          <div
            style={{ padding: "2em", marginTop: "2em", marginBottom: "2em", textAlign: "center" }}
            variant="outlined"
          >
            {/* Large Success Icon */}
            <CheckCircleOutlineIcon color="success" style={{ fontSize: 100, marginBottom: "0.5em" }} />

            <Typography variant="h5" gutterBottom>
              {Translate.get("KsSignDone")}
            </Typography>

            <Typography variant="body1" paragraph>
              {Translate.get("DownloadPermitReminder")}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDownloadPdfReminder(false)}>{Translate.get("Close")}</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={editPermitContacts}>
        <PersonElectronicContactsCrud
          actorId={editPermitContacts?.actorId}
          dataId={editPermitContacts?.dataId}
          apiFetchActor={getHolderActor}
          apiSaveActorElectronicContacts={updateHolderActorElectronicContacts}
          onActorSaved={() => {
            const successMessage = enqueueSnackbar(Translate.get("ChangesSaved"), {
              variant: "success",
              autoHideDuration: 6000,
              anchorOrigin: { vertical: "bottom", horizontal: "center" },
              onClick: () => closeSnackbar(successMessage),
            });
          }}
          onClose={async () => {
            await apiLoadPermits();
            setEditPermitContacts(null);
          }}
        />
      </Dialog>
    </>
  );
};
export default ConfirmPermits;
